import {
  type AssetsHttpGetAssetsByAssetIdHistoryQuery,
  httpGetAssetsByAssetIdHistory,
} from '@iconik-io/iconik-api/src/services/assets';
import { httpGetJobs } from '@iconik-io/iconik-api/src/services/jobs';

import type { AppDispatch, GetState } from '../../store/types';
import { setEntityHistory } from './slice';

export function getEntityHistory(
  entityId: string,
  params: AssetsHttpGetAssetsByAssetIdHistoryQuery = {},
) {
  return (dispatch: AppDispatch, getState: GetState): Promise<unknown> => {
    const history =
      getState().assetHistoryReducer.entityHistory[entityId] ?? {};
    if (params.page && history.pages && params.page > history.pages) {
      dispatch(setEntityHistory({ entityId, history }));
      return Promise.resolve();
    }

    return dispatch(httpGetAssetsByAssetIdHistory(entityId, params)).then(
      async ({ body }) => {
        const payload = { ...body };

        const jobIds = payload.objects
          .map((entity) => entity.job_id)
          .filter((jobId): jobId is string => Boolean(jobId));

        const jobIdsPreparedForSearch = jobIds.join(',');

        await dispatch(
          httpGetJobs({
            ids: jobIdsPreparedForSearch,
            _exists_: 'metadata.automation_id',
          }),
        );

        if (history.page && params.page === history.page + 1) {
          const objects = history.objects ?? [];
          const newObjects = payload.objects ?? [];

          payload.objects = [...objects, ...newObjects];
        }
        return dispatch(
          setEntityHistory({
            entityId,
            history: payload,
          }),
        );
      },
    );
  };
}
